import { TUTORIAL_COPY, TUTORIAL_STEPS, TOTAL_STEPS } from '../../constants/tutorialContent'
import { Button } from '../ui/button'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../ui/dialog'

/**
 * TutorialWelcome — step 1, full-screen modal (no spotlight). Three panels:
 * survived / bunker=home / outside=gear-at-risk. Focus trapped by Radix.
 * Esc collapses to the pill; skip stays an explicit click (§7).
 */

export default function TutorialWelcome({ onBegin, onSkip, onCollapse }) {
    const panels = TUTORIAL_STEPS[0].panels

    return (
        <div className="tcd-modal-scrim" data-testid="tutorial-welcome">
            <Dialog open onOpenChange={(open) => { if (!open) onCollapse() }}>
                <DialogContent
                    className="tcd-welcome z-[60]"
                    aria-describedby={undefined}
                    onEscapeKeyDown={(e) => { e.preventDefault(); onCollapse() }}
                >
                    <DialogHeader>
                        <DialogTitle>{TUTORIAL_STEPS[0].title}</DialogTitle>
                        <DialogDescription asChild>
                            <span className="tcd-callout__chip">{`LOG 1/${TOTAL_STEPS}`}</span>
                        </DialogDescription>
                    </DialogHeader>
                    <div className="tcd-welcome__panels">
                        {panels.map((p) => (
                            <div key={p.title} className="tcd-welcome__panel">
                                <div className="tcd-welcome__panel-title">{p.title}</div>
                                <div className="tcd-welcome__panel-body">{p.body}</div>
                            </div>
                        ))}
                    </div>
                    <DialogFooter className="tcd-welcome__footer">
                        <span>{TUTORIAL_COPY.welcomeFooter}</span>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                            <button type="button" className="tcd-callout__skip" onClick={onSkip}>
                                {TUTORIAL_COPY.skip}
                            </button>
                            <Button onClick={onBegin}>{TUTORIAL_COPY.welcomeCta}</Button>
                        </div>
                        <span className="sr-only">{TUTORIAL_COPY.stepAnnounce(1, TUTORIAL_STEPS[0].title)}</span>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </div>
    )
}
